import { Component, Input, OnInit } from '@angular/core';
import { QueryService } from '../../@tools/query';
import { DataService } from '../../data.service';

@Component({
    selector: 'app-create-record',
    templateUrl: './create-record.component.html',
    styleUrls: [ './create-record.component.scss' ]
})
export class CreateRecordComponent implements OnInit {

    @Input() table: string;
    @Input() full;

    data = {};

    showRelation = false;
    relation_model = '';
    relation_field = '';
    relation_to = '';
    relation_row;


    constructor(public DATA: DataService, private query: QueryService) {
    }

    ngOnInit(): void {

    }

    defaultOrder() {
        return 0;
    }

    create() {
        this.query.post(this.table, this.data);
    }

    changeSelect(field, value) {
        this.data[field] = value;
    }

    fileChanged(field, row, fileList: FileList) {
        if (fileList.length > 0) {
            let file: File = fileList[0];
            row[field] = file;

            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (_event) => {
                row['preview_' + field] = reader.result;
            };
        }
    }

    onChangeId(data) {
        this.relation_row[this.relation_to] = data.id;
        this.showRelation = false;
    }

    showRelationTable(type, field, row) {
        let rel = type.split(':');
        this.relation_model = rel[1];       // какая модель
        this.relation_field = rel[2];       // из какого поля подставлять
        this.relation_to = field;           // в какое поле подставлять
        this.relation_row = row;
        this.showRelation = true;
    }
}
